import React from 'react';

export const IconCursor = () => (
  <svg width="24" height="24" strokeWidth="1.8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M3 3l7.4 17.1a.5.5 0 0 0 .9 0l2.1-5.1 5.1-2.1a.5.5 0 0 0 0-.9L3 3z"/></svg>
);
export const IconT = () => (
  <svg width="24" height="24" strokeWidth="1.8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path d="M4 4h16M12 4v16"/></svg>
);
export const IconShape = () => (
  <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path stroke="currentColor" strokeLinejoin="round" strokeWidth="2" d="M4.07141 14v6h5.99999v-6H4.07141Zm4.5-4h6.99999l-3.5-6-3.49999 6Zm7.99999 10c1.933 0 3.5-1.567 3.5-3.5s-1.567-3.5-3.5-3.5-3.5 1.567-3.5 3.5 1.567 3.5 3.5 3.5Z"/>
  </svg>
);
export const IconPen = () => (
  <svg className="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
    <path fillRule="evenodd" d="M14 4.182A4.136 4.136 0 0 1 16.9 3c1.087 0 2.13.425 2.899 1.182A4.01 4.01 0 0 1 21 7.037c0 1.068-.43 2.092-1.194 2.849L18.5 11.214l-5.8-5.71 1.287-1.31.012-.012Zm-2.717 2.763L6.186 12.13l2.175 2.141 5.063-5.218-2.141-2.108Zm-6.25 6.886-1.98 5.849a.992.992 0 0 0 .245 1.026 1.03 1.03 0 0 0 1.043.242L10.282 19l-5.25-5.168Zm6.954 4.01 5.096-5.186-2.218-2.183-5.063 5.218 2.185 2.15Z" clipRule="evenodd"/>
  </svg>
);
export const IconHighlighter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path fillRule="evenodd" d="M11.096.644a2 2 0 0 1 2.791.036l1.433 1.433a2 2 0 0 1 .035 2.791l-.413.435-8.07 8.995a.5.5 0 0 1-.372.166h-3a.5.5 0 0 1-.234-.058l-.412.412A.5.5 0 0 1 2.5 15h-2a.5.5 0 0 1-.354-.854l1.412-1.412A.5.5 0 0 1 1.5 12.5v-3a.5.5 0 0 1 .166-.372l8.995-8.07zm-.115 1.47L2.727 9.52l3.753 3.753 7.406-8.254zm3.585 2.17.064-.068a1 1 0 0 0-.017-1.396L13.18 1.387a1 1 0 0 0-1.396-.018l-.068.065zM5.293 13.5 2.5 10.707v1.586L3.707 13.5z"/>
  </svg>
);
export const IconEraser = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M8.086 2.207a2 2 0 0 1 2.828 0l3.879 3.879a2 2 0 0 1 0 2.828l-5.5 5.5A2 2 0 0 1 7.879 15H5.12a2 2 0 0 1-1.414-.586l-2.5-2.5a2 2 0 0 1 0-2.828zm2.121.707a1 1 0 0 0-1.414 0L4.16 7.547l5.293 5.293 4.633-4.633a1 1 0 0 0 0-1.414zM8.746 13.547 3.453 8.254 1.914 9.793a1 1 0 0 0 0 1.414l2.5 2.5a1 1 0 0 0 .707.293H7.88a1 1 0 0 0 .707-.293z"/>
  </svg>
);
export const IconSticker = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 16 16">
    <path d="M2.5 1A1.5 1.5 0 0 0 1 2.5v11A1.5 1.5 0 0 0 2.5 15h6.086a1.5 1.5 0 0 0 1.06-.44l4.915-4.914A1.5 1.5 0 0 0 15 8.586V2.5A1.5 1.5 0 0 0 13.5 1zM2 2.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V8H9.5A1.5 1.5 0 0 0 8 9.5V14H2.5a.5.5 0 0 1-.5-.5zm7 11.293V9.5a.5.5 0 0 1 .5-.5h4.293z"/>
  </svg>
);
export const IconTrash = () => (
  <svg width="24" height="24" strokeWidth="1.8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><rect x="5" y="6" width="14" height="12" rx="2"/><path d="M10 11v4M14 11v4"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
);
export const IconRect = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <rect x="4" y="4" width="16" height="16" rx="4" fill="none" stroke="currentColor" strokeWidth="2"/>
  </svg>
);
export const IconCircle = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" strokeWidth="2"/>
  </svg>
);
export const IconTriangle = () => (
  <svg width="24" height="24" strokeWidth="2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <polygon points="12,4 20,20 4,20"/>
  </svg>
);
export const IconArrow = () => (
  <svg width="24" height="24" strokeWidth="2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <line x1="4" y1="12" x2="20" y2="12"/>
    <polyline points="14,6 20,12 14,18"/>
  </svg>
);
export const IconLine = () => (
  <svg width="24" height="24" strokeWidth="2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <line x1="4" y1="20" x2="20" y2="4"/>
  </svg>
);
export const IconMessage = () => (
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path d="M4 4h16v12H8l-4 4V4z" fill="none" stroke="currentColor" strokeWidth="2"/>
    <path d="M8 16l-4 4v-4h4z" fill="currentColor"/>
  </svg>
);
